module.exports = __webpack_public_path__ + "assets/404.4dc847a5.svg";